import React,{ Component, Fragment, useState } from 'react';
import {useMutation, useQuery,withApollo} from 'react-apollo';
import {GET_PROJECT_IMAGES,DELETE_PROJECT_IMAGES,UPLOAD_PROJECT_IMAGES} from '../Queries/projectImage';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import {SERVER_URL,PROJECT_IMAGE_URL} from '../../../Config/index';
import ModalNotification from '../../../GlobalComponents/ModalNotification';
import Notification from '../../../Library/notification';
import ProjectImageLib from '../Library/projectImage';
import Helper from '../../../Library/helper';
import translate from '../../Translations/index';


const ProjectImages = (props) => {

    const projectPhotoLib = new ProjectImageLib(props);

    const [showDeleteInfo,setDeleteInfo] = useState(false);
    const [projectImagesID,setProjectImages] = useState([]);

    var {data,loading,error:getError} = useQuery(GET_PROJECT_IMAGES,{
        variables:{
            projectID:props.projectID
        }
    })

    const [deleteProjectImages,{loading:deleteLoading}] = useMutation(DELETE_PROJECT_IMAGES,{
        variables:{
            projectID: props.projectID
        },
        update(cache,response) {
            projectPhotoLib.updateProjectImagesAfterDelete(cache,response,props.projectID);
        }
    })
    
    const [uploadProjectImages,{error:uploadError,loading:uploadLoading}] = useMutation(UPLOAD_PROJECT_IMAGES,{
        update(cache,response) {
            projectPhotoLib.updateProjectImages(cache,response,props.projectID);
        }
    });

    const showDelNotifi = () => {
        if(projectImagesID.length > 0){
            setDeleteInfo(true);
        }else{
            let notify = new Notification();
            notify.setNotification(null,translate.t("ItemNotSelected"),false,true,props.client);
        }
    }

    const delProjectImage = (action) => {

        if(action){

            deleteProjectImages({variables:{projectImagesIDs:projectImagesID}});
        }

        setDeleteInfo(false);
    }

    var error = "";
    if(getError || uploadError){

        var err = getError || uploadError;
        const helper = new Helper(); 
        error = "ERROR: " + helper.getApolloErrorText(err);
    }

    if(deleteLoading)loading = deleteLoading;
    if(uploadLoading)loading = uploadLoading;

    return(

        <Fragment>

            {error ?
                <Error text={error} />
                 :
                <Fragment>

                    <div className="form-group input-group">
                        <div className="custom-file">
                            
                            <input
                                type="file"
                                className="custom-file-input"
                                id="customFile"
                                required
                                multiple
                                onChange={
                                    ({ target: { validity, files: files } }) => {
                                        validity.valid && uploadProjectImages({ variables: { files:files, projectID: props.projectID } });
                                    }   
                                }
                            />
                            <label className="custom-file-label" htmlFor="customFile">{translate.t("ChoosePhotos")}</label>
                        </div>
                        <div className="input-group-append">
                            <button className="btn btn-danger btn-delete-files" type="button" onClick={() => showDelNotifi()}>{translate.t("DeleteSelectedPhotos")}</button>
                        </div>
                    </div>

                    {loading ? 

                        <Loading />
                
                        :
                
                        <div className="row">
                    
                            {data.projectImages && data.projectImages.map((item,index) => {

                                for(let i in props.formData.images){
                                    
                                    if(item.projectImageID == props.formData.images[i].projectImageID){
                                        if(props.formData.images[i].description || props.formData.images[i].description == "")item.description = props.formData.images[i].description;
                                        
                                    }
                                }
                        
                                return(
                                    <div key={index} className="col-2 form-group">
                                        <div className="image-item">
                                            <div className="menu-item">
                                                <input type="checkbox" name="delete" onChange={(e) => projectPhotoLib.setDeleteImage(e,item.projectImageID,projectImagesID,setProjectImages)} />
                                            </div>
                                            
                                            <img src={SERVER_URL + "/" + PROJECT_IMAGE_URL + "/p-" + props.projectID + "/mala_" + item.name} />

                                            
                                            
                                        </div>
                                        <div>
                                            <input className="form-control" placeholder="popis" type="text" name="description" value={item.description} onChange={(e) => projectPhotoLib.setImages(e,item.projectImageID,props.formData,props.setFormData)} />
                                        </div>
                                    </div>
                                )
                            })}         
                    
                        </div>

                    }
                
                    {showDeleteInfo && <ModalNotification yesNo={true} text={'Opravdu chcete vymazat vybrané obrázky ?'} callback={delProjectImage} />}
                    
                </Fragment>
            }
        
        </Fragment>
    )

}

export default withApollo(ProjectImages);









